import qs from 'qs';
import { useLocation } from 'react-router-dom';

export const useQuery = <T = Record<string, string>>() => {
  const { search } = useLocation();

  return qs.parse(search, { ignoreQueryPrefix: true }) as unknown as T;
};
